import { MRadio } from '@Components/Base';
import { Col, Form, Row, Flex } from 'antd';
import { FormikProps } from 'formik';
import { Option } from '@Components/types/options';

interface RadioProps<T> {
  formik: FormikProps<T>;
  options: Option[];
  formikKey: string;
  label?: string;
  disabled?: boolean;
}

const Radio = <T,>({
  formik,
  options,
  formikKey,
  label,
  disabled,
}: RadioProps<T>): JSX.Element => {
  const { value } = formik.getFieldMeta(formikKey);

  return (
    <Row>
      <Col span={24}>
        <Form.Item label={label}>
          <Flex vertical gap="small">
            {options.map((option) => (
              <MRadio
                key={option.value}
                id={`${formikKey}-${option.value}`}
                value={option.value}
                name={formikKey}
                labelText={option.label}
                checked={value === option.value}
                onChange={(event) => {
                  formik.setFieldValue(formikKey, event.target.value);
                }}
                onBlur={() => {
                  formik.setFieldTouched(formikKey, true);
                }}
                disabled={disabled}
              />
            ))}
          </Flex>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default Radio;
